import classNames from 'classnames';

import { useThemeClassName } from '../../contexts/ThemeContext';
import LuggageIcon from '../icons/Luggage';

import styles from '../../../styles/partials/game-points.module.css';

interface GamePointsProps {
    points?: number;
    maximum?: number;
    trailingText?: string;
    withIcon?: boolean;
    withMaximum?: boolean;
    className?: string;
    timeClassName?: string;
    onComplete?: () => void;
    onChange?: () => void;
}

function GamePoints({
    points = null,
    maximum = null,
    trailingText = ' pts',
    withIcon = true,
    withMaximum = false,
    className = null,
    timeClassName = null,
}: GamePointsProps) {
    const themeClassName = useThemeClassName(styles);
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.almostDone]: maximum !== null && points > maximum - 4,
                    [styles.urgent]: maximum !== null && points > maximum - 2,
                },
                themeClassName,
                className,
            ])}
        >
            <div className={styles.pill}>
                {withIcon ? <LuggageIcon className={styles.icon} /> : null}
                <div
                    className={classNames([
                        styles.time,
                        { [timeClassName]: timeClassName !== null },
                    ])}
                >
                    {points}
                    {withMaximum ? ` / ${maximum}` : trailingText}
                </div>
            </div>
        </div>
    );
}

export default GamePoints;
